module.exports = __webpack_public_path__ + "static/IMG_0407-36f050eed7bb1ccffa6fcdaf5814fc76.jpg";